import { useEffect, useState } from 'react'
import { SIZE_SMALL, SIZE_SMALLER } from './styles/mediaQueries'

const getWindowInfo = () => ({
  isSmallerScreen: false,
  isSmallScreen: false,
})

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState(getWindowInfo())

  useEffect(() => {
    const smallScreen = window.matchMedia(`(max-width: ${SIZE_SMALL}px)`)
    const smallerScreen = window.matchMedia(`(max-width: ${SIZE_SMALLER}px)`)

    const handleSmallScreen = (evt: any) => {
      setWindowSize((previousWindowSize) => ({
        isSmallScreen: evt.matches,
        isSmallerScreen: previousWindowSize.isSmallerScreen,
      }))
    }

    const handleSmallerScreen = (evt: any) => {
      setWindowSize((previousWindowSize) => ({
        isSmallScreen: previousWindowSize.isSmallScreen,
        isSmallerScreen: evt.matches,
      }))
    }
    smallScreen.addEventListener('change', handleSmallScreen)
    smallerScreen.addEventListener('change', handleSmallerScreen)
    handleSmallScreen(smallScreen)
    handleSmallerScreen(smallerScreen)

    // Cleanup the event listener on component unmount
    return () => {
      smallScreen.removeEventListener('change', handleSmallScreen)
      smallerScreen.removeEventListener('change', handleSmallerScreen)
    }
  }, []) // Empty dependency array ensures the effect runs only on mount and unmount

  return windowSize
}

export default useWindowSize
